"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineJoinRecipe = void 0;
const prepare_1 = require("../types-internal/prepare");
function combineJoinRecipe(combine, map, reduce, resolver) {
    return function combineJoin(baseKey) {
        var _a;
        let keyA;
        let keyB;
        if (baseKey) {
            keyB = (0, prepare_1.prepare)(baseKey);
            keyA = ([a]) => keyB(a);
        }
        return ((_a = reduce.call(this, (result, nextIterable) => result
            ? resolver(combine.call(result, nextIterable, keyA, keyB), (combined) => map.call(combined, ([a, b]) => [...a, b]))
            : map.call(nextIterable, (x) => [x]), undefined)) !== null && _a !== void 0 ? _a : []);
    };
}
exports.combineJoinRecipe = combineJoinRecipe;
